export default __webpack_public_path__ + "static/media/warning.7b1851a9.svg";